module.exports = __webpack_public_path__ + "static/media/pg_table_tablet_blank_bg.17c1e91e.jpg";